import axios from 'axios';
import type { INewAgreementValues } from '../types';

export async function createFleetCompany(fields: INewAgreementValues) {
	const payload = {
		telematicSolutionProviderId: fields.tsp,
		fleetIdentifier: fields.fleetIdentifier,
		name: fields.name,
		address: fields.address,
		city: fields.city,
		stateId: fields.state,
		zip: fields.zip,
		phone: fields.phone,
		representativeName: fields.representativeName,
		representativeTitle: fields.representativeTitle,
		representativeEmail: fields.representativeEmail,
		representativePhone: fields.representativePhone,
	};
	return axios.post(`/api/fleetcompany`, payload, { headers: { 'Content-Type': 'application/json' } }).then(
		async res => res.data,
		err => Promise.reject(err)
	);
}

export async function updateFleetCompany(fields: INewAgreementValues, fleetCompanyId: string) {
	const payload = {
		telematicSolutionProviderId: fields.tsp,
		fleetIdentifier: fields.fleetIdentifier,
		name: fields.name,
		address: fields.address,
		city: fields.city,
		stateId: fields.state,
		zip: fields.zip,
		phone: fields.phone,
		representativeName: fields.representativeName,
		representativeTitle: fields.representativeTitle,
		representativeEmail: fields.representativeEmail,
		representativePhone: fields.representativePhone,
	};
	return axios
		.patch(`/api/fleetcompany/${fleetCompanyId}`, payload, { headers: { 'Content-Type': 'application/json' } })
		.then(
			async res => res.data,
			err => Promise.reject(err)
		);
}

export const FleetCompanyService = {
	createFleetCompany,
	updateFleetCompany,
};
